export const eligibilityServiceTypes = [
    { value: "84",  label: "84 - Abortion" },
    { value: "64",  label: "64 - Acupuncture" },
    { value: "28",  label: "28 - Adjunctive Dental Services" },
    { value: "85",  label: "85 - AIDS" },
    { value: "57",  label: "57 - Air Transportation" },
    { value: "AJ",  label: "AJ - Alcoholism" },
    { value: "79",  label: "79 - Allergy Testing" },
    { value: "GY",  label: "GY - Allergy" },
    { value: "15",  label: "15 - Alternate Method Dialysis" },
    { value: "13",  label: "13 - Ambulatory Service Center Facility" },
    { value: "7",  label: "7 - Anesthesia" },
    { value: "97",  label: "97 - Anesthesiologist" },
    { value: "71",  label: "71 - Audiology Exam" },
    { value: "10",  label: "10 - Blood Charges" },
    { value: "B2",  label: "B2 - Brand Name Prescription Drug - Formulary" },
    { value: "B3",  label: "B3 - Brand Name Prescription Drug - Non-Formulary" },
    { value: "91",  label: "91 - Brand Name Prescription Drug" },
    { value: "B1",  label: "B1 - Burn Care" },
    { value: "58",  label: "58 - Cabulance" },
    { value: "87",  label: "87 - Cancer" },
    { value: "BG",  label: "BG - Cardiac Rehabilitation" },
    { value: "BL",  label: "BL - Cardiac" },
    { value: "CQ",  label: "CQ - Case Management" },
    { value: "78",  label: "78 - Chemotherapy" },
    { value: "34",  label: "34 - Chiropractic Office Visits" },
    { value: "33",  label: "33 - Chiropractic" },
    { value: "16",  label: "16 - Chronic Renal Disease (CRD) Equipment" },
    { value: "BD",  label: "BD - Cognitive Therapy" },
    { value: "3",  label: "3 - Consultation" },
    { value: "C1",  label: "C1 - Coronary Care" },
    { value: "BC",  label: "BC - Day Care (Psychiatric)" },
    { value: "37",  label: "37 - Dental Accident" },
    { value: "35",  label: "35 - Dental Care" },
    { value: "36",  label: "36 - Dental Crowns" },
    { value: "DG",  label: "DG - Dermatology" },
    { value: "DS",  label: "DS - Diabetic Supplies" },
    { value: "23",  label: "23 - Diagnostic Dental" },
    { value: "5",  label: "5 - Diagnostic Lab" },
    { value: "73",  label: "73 - Diagnostic Medical" },
    { value: "4",  label: "4 - Diagnostic X-Ray" },
    { value: "76",  label: "76 - Dialysis" },
    { value: "63",  label: "63 - Donor Procedures" },
    { value: "AK",  label: "AK - Drug Addiction" },
    { value: "12",  label: "12 - Durable Medical Equipment Purchase" },
    { value: "18",  label: "18 - Durable Medical Equipment Rental" },
    { value: "DM",  label: "DM - Durable Medical Equipment" },
    { value: "86",  label: "86 - Emergency Services" },
    { value: "BP",  label: "BP - Endocrine" },
    { value: "26",  label: "26 - Endodontics" },
    { value: "AR",  label: "AR - Experimental Drug Therapy" },
    { value: "BR",  label: "BR - Eye" },
    { value: "CP",  label: "CP - Eyewear and Eyewear Accessories" },
    { value: "82",  label: "82 - Family Planning" },
    { value: "CO",  label: "CO - Flu Vaccination" },
    { value: "AM",  label: "AM - Frames" },
    { value: "89",  label: "89 - Free Standing Prescription Drug" },
    { value: "BN",  label: "BN - Gastrointestinal" },
    { value: "60",  label: "60 - General Benefits" },
    { value: "GF",  label: "GF - Generic Prescription Drug - Formulary" },
    { value: "GN",  label: "GN - Generic Prescription Drug - Non-Formulary" },
    { value: "92",  label: "92 - Generic Prescription Drug" },
    { value: "BT",  label: "BT - Gynecological" },
    { value: "30",  label: "30 - Health Benefit Plan Coverage" },
    { value: "42",  label: "42 - Home Health Care" },
    { value: "43",  label: "43 - Home Health Prescriptions" },
    { value: "44",  label: "44 - Home Health Visits" },
    { value: "45",  label: "45 - Hospice" },
    { value: "53",  label: "53 - Hospital - Ambulatory Surgical" },
    { value: "51",  label: "51 - Hospital - Emergency Accident" },
    { value: "52",  label: "52 - Hospital - Emergency Medical" },
    { value: "48",  label: "48 - Hospital - Inpatient" },
    { value: "50",  label: "50 - Hospital - Outpatient" },
    { value: "49",  label: "49 - Hospital - Room and Board" },
    { value: "47",  label: "47 - Hospital" },
    { value: "80",  label: "80 - Immunizations" },
    { value: "BA",  label: "BA - Independent Medical Evaluation" },
    { value: "83",  label: "83 - Infertility" },
    { value: "72",  label: "72 - Inhalation Therapy" },
    { value: "IC",  label: "IC - Intensive Care" },
    { value: "BS",  label: "BS - Invasive Procedures" },
    { value: "61",  label: "61 - In-vitro Fertilization" },
    { value: "AO",  label: "AO - Lenses" },
    { value: "59",  label: "59 - Licensed Ambulance" },
    { value: "54",  label: "54 - Long Term Care" },
    { value: "BM",  label: "BM - Lymphatic" },
    { value: "90",  label: "90 - Mail Order Prescription Drug" },
    { value: "BW",  label: "BW - Mail Order Prescription Drug: Brand Name" },
    { value: "BX",  label: "BX - Mail Order Prescription Drug: Generic" },
    { value: "55",  label: "55 - Major Medical" },
    { value: "CM",  label: "CM - Mammogram, High Risk Patient" },
    { value: "CN",  label: "CN - Mammogram, Low Risk Patient" },
    { value: "BE",  label: "BE - Massage Therapy" },
    { value: "69",  label: "69 - Maternity" },
    { value: "27",  label: "27 - Maxillofacial Prosthetics" },
    { value: "1",  label: "1 - Medical Care" },
    { value: "56",  label: "56 - Medically Related Transportation" },
    { value: "CG",  label: "CG - Mental Health Facility - Inpatient" },
    { value: "CH",  label: "CH - Mental Health Facility - Outpatient" },
    { value: "CE",  label: "CE - Mental Health Provider - Inpatient" },
    { value: "CF",  label: "CF - Mental Health Provider - Outpatient" },
    { value: "MH",  label: "MH - Mental Health" },
    { value: "62",  label: "62 - MRI/CAT Scan" },
    { value: "NI",  label: "NI - Neonatal Intensive Care" },
    { value: "BQ",  label: "BQ - Neurology" },
    { value: "65",  label: "65 - Newborn Care" },
    { value: "AQ",  label: "AQ - Nonmedically Necessary Physical" },
    { value: "BI",  label: "BI - Nursery" },
    { value: "BU",  label: "BU - Obstetrical" },
    { value: "BV",  label: "BV - Obstetrical/Gynecological" },
    { value: "AD",  label: "AD - Occupational Therapy" },
    { value: "ON",  label: "ON - Oncology" },
    { value: "40",  label: "40 - Oral Surgery" },
    { value: "38",  label: "38 - Orthodontics" },
    { value: "BK",  label: "BK - Orthopedic" },
    { value: "9",  label: "9 - Other Medical" },
    { value: "77",  label: "77 - Otological Exam" },
    { value: "BB",  label: "BB - Partial Hospitalization (Psychiatric)" },
    { value: "66",  label: "66 - Pathology" },
    { value: "BH",  label: "BH - Pediatric" },
    { value: "24",  label: "24 - Periodontics" },
    { value: "88",  label: "88 - Pharmacy" },
    { value: "AE",  label: "AE - Physical Medicine" },
    { value: "PT",  label: "PT - Physical Therapy" },
    { value: "BY",  label: "BY - Physician Visit - Office: Sick" },
    { value: "BZ",  label: "BZ - Physician Visit - Office: Well" },
    { value: "32",  label: "32 - Plan Waiting Period" },
    { value: "19",  label: "19 - Pneumonia Vaccine" },
    { value: "95",  label: "95 - Podiatry - Nursing Home Visits" },
    { value: "94",  label: "94 - Podiatry - Office Visits" },
    { value: "93",  label: "93 - Podiatry" },
    { value: "17",  label: "17 - Pre-Admission Testing" },
    { value: "CB",  label: "CB - Private Duty Nursing - Home" },
    { value: "CA",  label: "CA - Private Duty Nursing - Inpatient" },
    { value: "74",  label: "74 - Private Duty Nursing" },
    { value: "A3",  label: "A3 - Professional (Physician) Visit - Home" },
    { value: "99",  label: "99 - Professional (Physician) Visit - Inpatient" },
    { value: "A1",  label: "A1 - Professional (Physician) Visit - Nursing Home" },
    { value: "98",  label: "98 - Professional (Physician) Visit - Office" },
    { value: "A0",  label: "A0 - Professional (Physician) Visit - Outpatient" },
    { value: "A2",  label: "A2 - Professional (Physician) Visit - Skilled Nursing Facility" },
    { value: "96",  label: "96 - Professional (Physician)" },
    { value: "75",  label: "75 - Prosthetic Device" },
    { value: "39",  label: "39 - Prosthodontics" },
    { value: "A7",  label: "A7 - Psychiatric - Inpatient" },
    { value: "A8",  label: "A8 - Psychiatric - Outpatient" },
    { value: "A5",  label: "A5 - Psychiatric - Room and Board" },
    { value: "A4",  label: "A4 - Psychiatric" },
    { value: "A6",  label: "A6 - Psychotherapy" },
    { value: "BF",  label: "BF - Pulmonary Rehabilitation" },
    { value: "PU",  label: "PU - Pulmonary" },
    { value: "6",  label: "6 - Radiation Therapy" },
    { value: "AB",  label: "AB - Rehabilitation - Inpatient" },
    { value: "AC",  label: "AC - Rehabilitation - Outpatient" },
    { value: "AA",  label: "AA - Rehabilitation - Room and Board" },
    { value: "A9",  label: "A9 - Rehabilitation" },
    { value: "14",  label: "14 - Renal Supplies in the Home" },
    { value: "RN",  label: "RN - Renal" },
    { value: "RT",  label: "RT - Residential Psychiatric Treatment" },
    { value: "46",  label: "46 - Respite Care" },
    { value: "25",  label: "25 - Restorative" },
    { value: "41",  label: "41 - Routine (Preventive) Dental" },
    { value: "AN",  label: "AN - Routine Exam" },
    { value: "81",  label: "81 - Routine Physical" },
    { value: "CL",  label: "CL - Screening laboratory" },
    { value: "CK",  label: "CK - Screening X-ray" },
    { value: "20",  label: "20 - Second Surgical Opinion" },
    { value: "AH",  label: "AH - Skilled Nursing Care - Room and Board" },
    { value: "AG",  label: "AG - Skilled Nursing Care" },
    { value: "BJ",  label: "BJ - Skin" },
    { value: "67",  label: "67 - Smoking Cessation" },
    { value: "22",  label: "22 - Social Work" },
    { value: "AF",  label: "AF - Speech Therapy" },
    { value: "CI",  label: "CI - Substance Abuse Facility - Inpatient" },
    { value: "CJ",  label: "CJ - Substance Abuse Facility - Outpatient" },
    { value: "AI",  label: "AI - Substance Abuse" },
    { value: "8",  label: "8 - Surgical Assistance" },
    { value: "CD",  label: "CD - Surgical Benefits - Facility" },
    { value: "CC",  label: "CC - Surgical Benefits - Professional (Physician)" },
    { value: "2",  label: "2 - Surgical" },
    { value: "21",  label: "21 - Third Surgical Opinion" },
    { value: "TC",  label: "TC - Transitional Care" },
    { value: "TN",  label: "TN - Transitional Nursery Care" },
    { value: "70",  label: "70 - Transplants" },
    { value: "UC",  label: "UC - Urgent Care" },
    { value: "11",  label: "11 - Used Durable Medical Equipment" },
    { value: "AL",  label: "AL - Vision (Optometry)" },
    { value: "68",  label: "68 - Well Baby Care" }
];